





































































import Component, { mixins } from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { BankModule, NavModule, ProfileModule } from "@/store";
import { User } from "@fgl/funfangle-sdk/dist/rest/profile";
import { mdbBtn, mdbIcon } from "mdbvue";
// import { VCol, VContainer, VRow } from 'vuetify/lib';
import { RouterIcons } from "@/router/RouterIcons";
import { RouterUtils } from "@/router/RouterUtils";

@Component({
  components: {
    mdbBtn,
    mdbIcon,
    // VCol,
    // VContainer,
    // VRow
  }
})
export default class BankDeposits extends mixins(RouterUtils) {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MQ = MQ;

  scheduledAllocations: any[] = [];

  get allowBankTransfers(): boolean {
    return this.navStore.allowBankTransfers;
  }

  get authorizedActiveUsers(): User[] {
    return this.profileStore.authorizedActiveUsers || [];
  }

  get contributingToActive(): User[] {
    return this.bankStore.contributingToActive || [];
  }

  get routerIcons(): RouterIcons { 
    return RouterIcons;
  }

  get userContributionsByCamper(): Record<string, number> {
    // console.log('userContributionByCamper', this.bankStore.userContributionByCamper);
    return this.bankStore.userContributionByCamper;
  }

  getBankUrl(person: User): string {
    return "/bank/" + person.userId + "/" + this.profileStore.organizationId;
  }
  getFutureFundsBalance(person: User) {
    let bal = 0.0;
    for (let i in this.scheduledAllocations) {
      let allocation = this.scheduledAllocations[i];
      if (allocation && allocation.authUserId === person.userId) {
        if (allocation.status === "pending") {
          bal = bal + allocation.amount;
        }
        if (allocation.status === "reversed") {
          bal = bal - allocation.amount;
        }
      }
    }
    return bal;
  }
  setPersonAndNav(person: User) {
    this.navStore.setSelectedUser(person);
    this.goBankAccountPage(person.userId || "UNSET");
  }
  mounted() {
    this.scheduledAllocations = this.bankStore.scheduledAllocations;
  }
}
